import "reflect-metadata";
import "~/styles/index.scss";

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import lang from "~/lang";

import {registerPlugins} from "~/lib/vue-plugins";
import {createService, createWSService, initServicesManager} from "~/lib/services/services-manager";
import {EnvConfig} from "~/lib/env-config";
import VueI18n from "vue-i18n";

async function start(){

  Vue.config.productionTip = false;
  Vue.config.performance = process.env.NODE_ENV !== 'production';

  initServicesManager({router, store});
  registerPlugins(Vue);

  createService({ name: "auth-service", root: EnvConfig("AUTH_SERVICE_URL") });
  createService({ name: "server-app",  root: EnvConfig("SERVER_APP_URL"), deffered: EnvConfig("WS_SERVER_APP_URL") });
  createWSService({ name: 'ws-server-app', rootPath: '', interceptAuth: true, server: EnvConfig("WS_SERVER_APP_URL") });


  await store.dispatch("restoreSession");
  // store.commit("deserializePrivacySettings");

  const i18n = new VueI18n({ locale: "fr",  messages: lang });

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app');

}

start().catch();
